import { i18n } from '@/i18n'
import store from '@/store'

export default (params) => {
  const role = store.getters['auth/role']
  const menu = [
    {
      menuId: 9,
      icon: 'recived',
      name: i18n.t('invoices.received_header'),
      path: 'invoicesreceived',
      use_parent_params: true,
      params_required: ['id'],
      registerNavFromMenu: false,
      sc: [
        {
          name: i18n.t('app.detail'),
          path: 'invoicesreceived/details',
          params,
          registerNavFromMenu: false,
          sc: [] // shorcuts
        },
        {
          name: i18n.t('historical.entity_name'),
          path: 'invoicesreceived/historical',
          params,
          registerNavFromMenu: false,
          sc: [] // shorcuts
        }
      ]
    }
  ]
  const submenuGroups = {
    name: i18n.t('groups.groups_link'),
    path: 'invoicesreceived/groups',
    params,
    registerNavFromMenu: false,
    sc: [] // shorcuts
  }
  if ([2, 7, 8, 3].includes(role)) {
    menu[0].sc.splice(1, 0, submenuGroups)
  }

  return menu
}
